<template>
  <div>
    <!--search form-->
    <el-form
      :inline="true"
      :model="searchForm"
      class="demo-form-inline"
      size="mini"
    >
      <el-form-item label="昵称">
        <el-input
          v-model="searchForm.nickname"
          placeholder="用户名"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          v-model="searchForm.phoneNo"
          placeholder="手机号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="性别">
        <el-select v-model="searchForm.gender" placeholder="请选择" clearable>
          <el-option
            v-for="item in genderOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="openId">
        <el-input
          v-model="searchForm.openId"
          placeholder="openId"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="appId">
        <el-input
          v-model="searchForm.appId"
          placeholder="appId"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadPage()">查询</el-button>
        <el-button icon="el-icon-download" @click="handleExport">导出</el-button>
      </el-form-item>
    </el-form>

    <!--table-->
    <el-table
      :data="tableData"
      stripe
      border
      style="width: 100%"
      size="mini"
      v-loading="loading"
    >
      <el-table-column prop="avatar" label="头像">
        <template slot-scope="scope">
          <!--圆形-->
          <el-image
            :src="scope.row.avatar"
            class="avatar"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="昵称"></el-table-column>
      <el-table-column prop="phoneNo" label="手机号"></el-table-column>
      <el-table-column prop="gender" label="性别">
        <template slot-scope="scope">
          <span>{{ scope.row.gender | genderFilter(genderOptions) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="city" label="城市"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <!---link-->
          <el-link
            type="primary"
            @click="handleDetail(scope.row)"
            :underline="false"
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <!--pagination-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    ></el-pagination>
  </div>
</template>
<script>
import { loadSubscriberPageApi,exportSubscriberApi } from "@/api/subscriber";
import axios from "axios";
import ip from "@/config/ip.js";
import store from "@/store/store";
export default {
  filters: {
    genderFilter: function(value, genderOptions) {
      const gender = genderOptions.find(item => {
        return item.value == value;
      });
      return gender ? gender.label : "未知";
    }
  },
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      genderOptions: [
        {
          label: "男",
          value: 1
        },
        {
          label: "女",
          value: 2
        },
        {
          label: "未知",
          value: 0
        }
      ],
      tableData: [],
      loading: false
    };
  },
  created() {},
  mounted() {
    this.loadPage();
  },
  methods: {
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.loading = true;
      loadSubscriberPageApi(this.searchForm)
        .then(resp => {
          if (resp.data.status == 100) {
            this.tableData = resp.data.results.list;
            this.searchForm.total = resp.data.results.total;
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.loadPage();
    },
    handleDetail(row) {
      this.$router.push({
        path: "/subscriberDetail",
        query: {
          id: row.id
        }
      });
    },
    handleExport() {
      const loading = this.$loading({
          lock: true,
          text: "正在生成文件，请稍等111...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        axios({
          url: `${ip.Ips.ip1}/biz/subscriber/export`,
          method: "post",
          headers: {
            token: `${store.state.token}`
          },
          data: this.searchForm,
          responseType: "blob"
        })
          .then(res => {
            loading.close();
            let fileName = res.headers["content-disposition"].split(";")[1].trim().split('filename=')[1].split('"')[1]
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              let blob = new Blob([res.data], {
                type: "application/vnd.ms-excel"
              });
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
              let blob = new Blob([res.data], {
                type: "application/vnd.ms-excel"
              });
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              link.setAttribute(
                "download",
                fileName
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          })
          .catch(error => {
            this.$Message.error(error.message);
          });
    },
  }
};
</script>
<style lang="scss" scoped>
/**头像 */
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// index.vue?cd497098